
import EmployerSidebar from '../components/Employer/EmployerSidebar';
import { Box, Grid } from '@mui/material';
import Navbar from '../components/Navbar';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ApplicantCard from '../components/Employer/ApplicantCard';
import Layout from '../assets/Layout';
import UserLayout from '../assets/UserLayout';

const CandidateApplicants = () => {
    const { user } = useSelector((state) => ({ ...state }));
    const navigate = useNavigate();

    useEffect(() => {
        // if (!localStorage.getItem("user")) {
        //     navigate('/');
        // }
    }, []);

    const cardData = [
        {
            name: "Anuj Sharma",
            image: "https://images.unsplash.com/photo-1490730141103-6cac27aaab94?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80",
            profile: "UI-UX Designer",
            age: "23",
            experience: "4",
            location: "Gurugram, Haryana, India",
            appliedFor: "UI-UX-Designer"
        },
        {
            name: "Anmol Singh",
            image: "https://plus.unsplash.com/premium_photo-1669688174637-92ff26cc0a9b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxleHBsb3JlLWZlZWR8OHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=60",
            profile: "MERN Developer",
            age: "24",
            experience: "5",
            location: "Noida, Uttar Pradesh, India",
            appliedFor: "CIO"
        },
        {
            name: "Anas Singh",
            image: "https://images.unsplash.com/photo-1681038429854-38596ec0d7f7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxleHBsb3JlLWZlZWR8MjB8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=600&q=60",
            profile: "React Developer",
            age: "23",
            experience: "2",
            location: "Noida, Uttar Pradesh, India",
            appliedFor: "Web Developer"
        }
    ]

    return (
        <>
            <Layout>
                <UserLayout>
                    <Grid container spacing={2} sx={{ mt: 8 }}>
                        {cardData?.map((item, index) => (
                            <ApplicantCard key={index} item={item} />
                        ))}
                    </Grid>
                </UserLayout>
            </Layout>
        </>
    );
};

export default CandidateApplicants;